import React from 'react';
import styled from 'styled-components';
import Footer from '../../Footer/Footer';
import ParallaxBanner from '../../common/Parralax-banner';
import ImageSlant from '../../common/image-slant';

import gardensImage from '../../../assets/rose-garden.jpg';
import bookClubImage from '../../../assets/book-club-image.jpg';
import woodlandImage from '../../../assets/capability.webp';
import castleImage from '../../../assets/castle2.png';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.offWhite};
  padding-top: 120px;

  @media (max-width: 768px) {
    padding-top: 100px;
  }
`;

const IntroSection = styled.section`
  max-width: 900px;
  margin: 4rem auto 2rem;
  padding: 0 2rem;
  text-align: center;
`;

const IntroTitle = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: 2.5rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1.5rem;

  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background-color: ${props => props.theme.colors.accent};
    margin: 1rem auto 0;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const IntroText = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  color: ${props => props.theme.colors.secondary};
  margin-bottom: 1rem;
`;

const FreeBadge = styled.span`
  display: inline-block;
  background-color: ${props => props.theme.colors.accent};
  color: white;
  font-size: 0.95rem;
  font-weight: 700;
  padding: 0.35rem 1rem;
  border-radius: 20px;
  letter-spacing: 0.05em;
  margin-bottom: 2rem;
  text-transform: uppercase;
`;

const ComingSoonSection = styled.section`
  background-color: ${props => props.theme.colors.greyBackground};
  padding: 4rem 2rem;
  margin: 2rem 0 0;
  text-align: center;
`;

const ComingSoonContent = styled.div`
  max-width: 700px;
  margin: 0 auto;
`;

const ComingSoonTitle = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: 2rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1.5rem;

  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background-color: ${props => props.theme.colors.accent};
    margin: 1rem auto 0;
  }
`;

const ComingSoonText = styled.p`
  font-size: 1.15rem;
  line-height: 1.8;
  color: ${props => props.theme.colors.secondary};
`;

const FreeClubs = () => {
  return (
    <PageContainer>
      <ParallaxBanner
        title="Free Clubs & Classes"
        subtitle="Discover, Learn & Connect at Belvoir Castle"
        image={castleImage}
      />

      <IntroSection>
        <FreeBadge>Free to Join</FreeBadge>
        <IntroTitle>Something for Everyone</IntroTitle>
        <IntroText>
          We're excited to launch a brand new programme of free clubs and classes at Belvoir Castle.
          Whether you have a passion for gardening, love getting lost in a great book, or want to
          explore the stunning natural beauty of our estate — there's a club for you.
        </IntroText>
        <IntroText>
          All clubs are free to join and open to castle visitors and members alike.
        </IntroText>
      </IntroSection>

      <ImageSlant
        image={gardensImage}
        title="Garden Discovery Walk"
        description="Every Thursday, 11am — Meet at Belvoir Bistro. Hosted by Belvoir Gardener Tom Webster. Join Tom for a guided walk and talk through the stunning gardens and estate at Belvoir Castle. Whether you're a keen gardener or simply love the outdoors, these relaxed sessions offer expert insight into the history, horticulture and hidden stories behind one of England's most beautiful estates. Free to attend; please book your ticket in advance."
        buttonText="Book now"
        buttonAction={() => window.open('https://www.belvoircastle.com/booking-journey?locationId=978&pageId=4962d4f3-fc67-475d-bd31-248ce512da94', '_blank')}
        imagePosition="left"
      />

      <ImageSlant
        image={bookClubImage}
        title="Belvoir Book Club"
        description="First Tuesday of every month — next session Tuesday 6th April. Hosted by the Belvoir Chaplain, Eddie Wynn MBE. Each session offers lively discussion, thoughtful conversation, and a chance to discover new reads in a relaxed café setting. Perfect for book lovers who enjoy sharing perspectives over coffee and good company. Free to attend; please book your ticket in advance. Refreshments included."
        buttonText="Book now"
        buttonAction={() => window.open('https://www.belvoircastle.com/booking-journey?locationId=978&pageId=ab4e21c4-31fc-48c6-a87a-7e394e35160e', '_blank')}
        imagePosition="right"
      />

      <ImageSlant
        image={woodlandImage}
        title="Woodland Walks & Nature Talks"
        description="Last Wednesday of every month, 11am — Meet at Belvoir Bistro. Hosted by our Estate Manager David Crossland, these relaxed and informative sessions explore local wildlife, seasonal changes, and the natural history of the estate. Perfect for those who enjoy fresh air, gentle exercise, and learning more about the landscape around them. Free to attend; please book your ticket in advance."
        buttonText="Book now"
        buttonAction={() => window.open('https://www.belvoircastle.com/booking-journey?locationId=978&pageId=027c88c6-911d-4135-9e63-9b301748aa88', '_blank')}
        imagePosition="left"
      />

      <ComingSoonSection>
        <ComingSoonContent>
          <ComingSoonTitle>Belvoir Digital Accounts — Coming Soon</ComingSoonTitle>
          <ComingSoonText>
            We're building Belvoir Digital Accounts — your personal online space where you'll be able
            to manage club and class bookings, track your membership, and access exclusive content,
            all in one place. Watch this space.
          </ComingSoonText>
        </ComingSoonContent>
      </ComingSoonSection>

      <Footer />
    </PageContainer>
  );
};

export default FreeClubs;
